import { lazy, Suspense, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";

const NotFound = lazy(() => import("../pages/NotFound"));

const Router = () => {
  const location = useLocation();

  // Start each new page at the top. Global CSS sets scroll-behavior: smooth,
  // so jump instantly rather than gliding up from the previous position.
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    }
  }, [location.pathname, location.hash]);

  // Scroll to "#section" links (e.g. /#contact) once the lazy-loaded page has rendered.
  useEffect(() => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      const element = document.getElementById(id);
      if (element || ++attempts > 40) {
        window.clearInterval(timer);
        element?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 50);
    return () => window.clearInterval(timer);
  }, [location.pathname, location.hash]);

  // Define which pages should show full navigation (home page) 
  const shouldRenderHeader = () => {
    return location.pathname === "/" || location.pathname === "/home";
  };

  return (
    <Suspense fallback={null}>
      <Styles />
      {/* Always show header and footer for public pages */}
      <Header showNav={shouldRenderHeader()} />
      <Switch>
        {routes.map((routeItem) => {
          const LazyComponent = lazy(() => import(`../pages/${routeItem.component}`));
          
          // All routes are now public - no authentication needed
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={LazyComponent}
            />
          );
        })}
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
